import axios from "axios";
import CVData from "../types/CVData";

const API_URL = process.env.REACT_APP_API_URL;

export const getCVById = async (cvId: string) => {
  const response = await axios.get(`${API_URL}/get-cv?cvId=${encodeURIComponent(cvId)}`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};

export const getAllCVs = async (opts?: {
  limit?: number;
  lastKey?: string;
}): Promise<CVData[] | { items: CVData[]; nextLastKey: string | null }> => {
  const params = new URLSearchParams();
  if (opts?.limit != null) params.set("limit", String(opts.limit));
  if (opts?.lastKey) params.set("lastKey", opts.lastKey);
  const query = params.toString();
  const url = `${API_URL}/all-cvs${query ? `?${query}` : ""}`;
  const response = await axios.get(url, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
};

// Add new CV or update existing CV
export const saveCVData = async (
  cv: CVData,
  options?: { sendEmailOnCreate?: boolean; notifyEmail?: string }
) => {
  const body: Record<string, unknown> = { cv };
  if (options?.sendEmailOnCreate) body.sendEmailOnCreate = true;
  if (options?.notifyEmail) body.notifyEmail = options.notifyEmail;

  const response = await axios.post(
    `${API_URL}/update-cv`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const deleteCV = async (cvId: string) => {
  const response = await axios.post(
    `${API_URL}/delete-cv`,
    { cvId },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};
